"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiceKeyImageProcessorModulePromise = exports.MemoryAllocatedInDiceKeyImageProcessorModule = void 0;
/// <reference types="emscripten" />
const DiceKeyImageProcessorModuleNotReallyAPromiseFn = require("./read-dicekey-js");
const webasm_module_memory_helper_1 = require("@dicekeys/webasm-module-memory-helper");
var MemoryAllocatedInDiceKeyImageProcessorModule;
(function (MemoryAllocatedInDiceKeyImageProcessorModule) {
    MemoryAllocatedInDiceKeyImageProcessorModule[MemoryAllocatedInDiceKeyImageProcessorModule["_"] = 0] = "_";
})(MemoryAllocatedInDiceKeyImageProcessorModule = exports.MemoryAllocatedInDiceKeyImageProcessorModule || (exports.MemoryAllocatedInDiceKeyImageProcessorModule = {}));
/**
 * Return a promise to a a web assembly module with our TypeScript helpers for allocating
 * memory within the web assembly memory space.
 */
exports.DiceKeyImageProcessorModulePromise = (0, webasm_module_memory_helper_1.getWebAsmModulePromiseWithAugmentedTypes)(DiceKeyImageProcessorModuleNotReallyAPromiseFn());
//# sourceMappingURL=dicekey-image-processor.js.map